// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"79":"24272e2a6654cce4d0be","661":"06bae153db6bc359e0ef","702":"693fe29e98e13e070d22"}[chunkId] + ".bundle.js";
};